import { render } from "./Footer.vue?vue&type=template&id=43e97204&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=43e97204&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e97204"]])